import * as angular from 'angular';

const DatalayerMMBConstants =  {
    DATALAYER_MMB_INFO: {
        AVIOS_EARNED: 'AviosEarned',
        CHANGE_ACCEPTANCE: 'ChangeAcceptance',
        CHANGE_TYPE: 'ChangeType',
        FLIGHT_STATUS: 'FlightStatus',
        ORIGINAL_ADVANCE_PURCHASE: 'OriginalAdvancePurchase',
        ORIGINAL_DATE: 'OriginalDate',
        ORIGINAL_LENGTH_STAY: 'OriginalLengthStay',
        PNR_TYPE: 'PNRType',
        PURCHASE_DATE: 'PurchaseDate',
        PURCHASE_TYPE: 'PurchaseType',
        SLICE1_ORIGINAL_DATE: 'Slice1OriginalDate',
        SLICE2_ORIGINAL_DATE: 'Slice2OriginalDate',
        SLICE3_ORIGINAL_DATE: 'Slice3OriginalDate',
        SLICE4_ORIGINAL_DATE: 'Slice4OriginalDate',
        SPECIAL_MEAL: 'SpecialMeal',
        PRODUCTS: 'products'
    },
    DATALAYER_MMB_VALUES: {
        YES: 'SI',
        NO: 'NO',
        TOTAL: 'total',
        PARTIAL : 'parcial',
        VOLUNTARY: 'voluntario',
        INVOLUTARY: 'involuntario'
    },
    DIGITAL_DATA_PROCESS:{
        MOAPIS: 'servicing',
        MOEMER: 'servicing',
        MOCONT: 'servicing',
        MOFFLY: 'servicing',
        MOPMR: 'servicing',
        MOCAPI: 'servicing',
        MOCEME: 'servicing',
        //MOCONT: 'servicing',
        MOCFFL: 'servicing',
        MOCPMR: 'servicing',
        OHMTDT: 'confirmacion onhold',
        OHINFO: 'confirmacion onhold',
        CNCLIT: 'confirmacion onhold',
        RTBKCF: 'confirmacion onhold',
        ATCFCNA: 'cambios voluntarios',
        ATCFOW: 'cambios voluntarios',
        ATCFRT: 'cambios voluntarios',
        ATCERD: 'cambios voluntarios',
        ATCPOW: 'cambios voluntarios',
        ATCPRT: 'cambios voluntarios',
        ATCERR: 'cambios voluntarios',
        ATCERT: 'cambios voluntarios',
        ATCSUM: 'cambios voluntarios',
        ATCPURC: 'cambios voluntarios',
        ATCBKCF: 'cambios voluntarios',
        ATCBKER: 'cambios voluntarios',
        ATCPSG: 'cambios voluntarios',
        MOANCI: 'ancillaries',
        MOSEAT: 'ancillaries',
        MOPRIO: 'ancillaries',
        MOBAGG: 'ancillaries',
        MOLUGG: 'ancillaries',
        MOMEAL: 'ancillaries',
        MOPURC: 'ancillaries',
        MOBKCF: 'ancillaries',
        IBMCYT: 'ancillaries',
        CIBKCF: 'cambio involuntario flex',
        CITOBK: 'cambios involuntarios flex total',
        CIPABK: 'cambios involuntarios flex parcial',
        CIPTBK: 'cambios involuntarios flex parcial',
        CITPURC: 'cambios involuntarios flex total',
        CIPPURC: 'cambios involuntarios flex parcial',
        CIPAPUR: 'cambios involuntarios flex parcial',
        CINTPUR: 'cambio involuntario total',
        CINPPUR: 'cambio involuntario parcial',
        CIBPURC: 'cambio involuntario flex'
    },
    ANCILLARIES_TYPES: {
        BAGGAGE: 'BAGGAGE',
        SEAT: 'SEAT',
        INSURANCE: 'INSURANCE',
        VEHICLE_RENTAL: 'VEHICLE_RENTAL',
        UPGRADING: 'UPGRADING',
        SPEQ: 'SPECIAL_EQUIPMENT',
        BOB: 'BOB',
        INTEGRATED_BOB: 'INTEGRATED_BOB',
        SPECIAL_MEALS: 'SPECIAL_MEALS',
        UPGRADING_BID: 'UPGRADING_BID',
        FLEXIBILITY: 'FLEXIBILITY_ON_DEMAND',
        PREORDER: 'PREORDER',
        PRIORITY_BOARDING: 'PRIORITY_BOARDING',
        THIRD_PARTY_COMPANIES: 'THIRD_PARTY_COMPANIES',
        CO2_FOOTPRINT: 'CO2_FOOTPRINT'
    },
    DIGITAL_DATA_STEP:{
        MOAPIS: 'actualizacion datos de la reserva',
        MOEMER: 'actualizar contacto de emergencias',
        MOCONT: 'actualizar datos de contacto',
        MOFFLY: 'actualizar datos de frequent flyer',
        MOPMR: 'solicitar asistencia especial',
        MOCAPI: 'confirmacion apis',
        MOCEME: 'confirmacion de la Actualizacion contacto de emergencias',
        //MOCONT: 'Actualizar datos de contacto',
        MOCFFL: 'confirmacion de la Actualizacion datos de frequent flyer',
        MOCPMR: 'confirmacion Solicitud asistencia especial',
        OHMTDT: 'recuperacion',
        OHINFO: 'pago',
        RTBKCF: 'confirmacion',
        CNCLIT: 'cancelacion',
        ATCFCNA: 'no disponible',
        ATCFOW: 'inicio',
        ATCFRT: 'inicio',
        ATCERD: 'error busqueda',
        ATCPOW: 'disponibilidad',
        ATCPRT: 'disponibilidad',
        ATCERR: 'error ribbon',
        ATCERT: 'error seleccion',
        ATCSUM: 'resumen',
        ATCPURC: 'pago',
        ATCBKCF: 'confirmacion',
        ATCBKER: 'comunicacion cortada',
        ATCPSG: 'sesion expirada',
        MOANCI: 'ancillaries',
        MOSEAT: 'seleccion de asiento',
        MOPRIO: 'prioridad de embarque',
        MOBAGG: 'seleccion de equipaje',
        MOLUGG: 'seleccion equipajes especiales',
        MOMEAL: 'menu a Bordo (menu necesidades especiales)',
        MOPURC: 'pago',
        MOBKCF: 'confirmacion',
        IBMCYT: 'hoteles coches',
        CIBKCF: 'confirmacion',
        CITOBK: 'confirmacion',
        CIPABK: 'confirmacion ow',
        CIPTBK: 'confirmacion rt',
        CITPURC: 'pago',
        CIPPURC: 'pago',
        CIPAPUR: 'pago',
        CINTPUR: 'pago',
        CINPPUR: 'pago',
        CIBPURC: 'pago'
    },
    QUADRIGAM_BY_DISRUPTION_FLOW: {
        'ALTERNATIVE_TOTAL_WITH_FLEXIBILIZATION': 'ALT_TOTAL_WITH_FLEX',
        'ALTERNATIVE_PARCIAL_WITH_FLEXIBILIZATION': 'ALT_PARC_WITH_FLEX',
        'ALTERANTIVE_TOTAL_WITHOUT_FLEXIBILIZATION': 'ALT_TOTAL_WITHOUT_FLEX',
        'ALTERNATIVE_PARCIAL_WITHOUT_FLEXIBILIZATION': 'ALT_PARC_WITHOUT_FLEX'
    }
};

angular.module('ib-datalayer-module').constant('DatalayerMMBConstants', DatalayerMMBConstants);
export type DatalayerMMBConstantsType = typeof DatalayerMMBConstants;
export { DatalayerMMBConstants };
